/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    a: "a",
    code: "code",
    hr: "hr",
    h2: "h2",
    h3: "h3",
    em: "em",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Theming"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Table of Contents"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#theming",
          children: "Theming"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.a, {
              href: "#integrated-theming",
              children: "Integrated theming"
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsx(_components.a, {
                  href: "#theme-component-and-usetheme-hook",
                  children: "Theme Component and useTheme Hook"
                })
              }), "\n", _jsx(_components.li, {
                children: _jsx(_components.a, {
                  href: "#brand-theming",
                  children: "Brand theming"
                })
              }), "\n"]
            }), "\n"]
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "#run-your-application-with-a-different-theme",
              children: "Run your application with a different theme"
            })
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.a, {
              href: "#wip-ready-to-use-themes",
              children: "WIP: Ready to use themes"
            }), "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsxs(_components.a, {
                  href: "#using-postcss-replace",
                  children: ["Using ", _jsx(_components.code, {
                    children: "postcss-replace"
                  })]
                })
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.p, {
      children: "Theming is an umbrella term of a wide range of different ways and needs of customization."
    }), "\n", _jsx(_components.p, {
      children: "This section covers some of the needs we've seen in DNB productions as of now."
    }), "\n", _jsxs(_components.p, {
      children: ["You may also check out the section in the contribution docs on ", _jsx(_components.a, {
        href: "/contribute/style-guides/theming/",
        children: "how to maintain and create a theme"
      }), " or ", _jsx(_components.a, {
        href: "/brand/development/",
        children: "how to deal with the brand as a developer"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Integrated theming"
    }), "\n", _jsx(_components.p, {
      children: "Eufemia supports theming right inside where all the style-sources lives. Having the ability to control different styles as close to the source as possible, will make it possible to carefully handle continuous improvements over time."
    }), "\n", _jsx(_components.p, {
      children: "Themes are independent style packages, which should not be imported in parallel. But rather either – or."
    }), "\n", _jsx(_components.h3, {
      children: "Theme Component and useTheme Hook"
    }), "\n", _jsxs(_components.p, {
      children: ["Eufemia has ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/theming/theme",
        children: "theming helpers"
      }), ", that lets you create nested theming solutions."]
    }), "\n", _jsx(_components.h3, {
      children: "Brand theming"
    }), "\n", _jsx(_components.p, {
      children: "Eufemia is a design system that aims to help DNB brands unleash their power."
    }), "\n", _jsx(_components.p, {
      children: "Eufemia is a system that is built on top of brand-assets. This means, it should be possible to swap out or extend these brand-assets."
    }), "\n", _jsx(_components.p, {
      children: "Therefore, instead of overwriting Eufemia (DNB main brand) styles inside projects, it is beneficial to create additional brand themes – directly where the source of the original brand lives."
    }), "\n", _jsxs(_components.p, {
      children: ["The default DNB brand theme is called: ", _jsx(_components.code, {
        children: "ui"
      }), " which stands for ", _jsx(_components.em, {
        children: "universal identity"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Run your application with a different theme"
    }), "\n", _jsx(_components.p, {
      children: "You can easily switch the static import of styles to a different theme:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "import '@dnb/eufemia/style/core' // or /basis, when \"dnb-core-style\" is used\n- import '@dnb/eufemia/style/themes/ui'\n+ import '@dnb/eufemia/style/themes/eiendom'\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Read more about ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/styling/consume-styles/#select-a-theme",
        children: "how to import styles"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "How ever, giving the user the ability to switch a theme during runtime, is a very much different challenge."
    }), "\n", _jsxs(_components.p, {
      children: ["The Eufemia Portal (documentation) uses ", _jsx(_components.a, {
        href: "https://github.com/dnbexperience/gatsby-plugin-eufemia-theme-handler",
        children: "gatsby-plugin-eufemia-theme-handler"
      }), " to handle it both in development and production mode."]
    }), "\n", _jsx(_components.h2, {
      children: "WIP: Ready to use themes"
    }), "\n", _jsxs(_components.p, {
      children: ["Right now, theres work going on to create Eufemia Themes that utilize both color and spacing and the ", _jsx(_components.a, {
        href: "/quickguide-designer/spatial-system",
        children: "Spatial system"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "The plan is to extend the documentation here later on, with how to select and use a theme inside an application."
    }), "\n", _jsxs(_components.h3, {
      children: ["Using ", _jsx(_components.code, {
        children: "postcss-replace"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["If your applications only need new colors or other CSS properties, you could simply replace all the properties with ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/postcss-replace",
        children: "postcss-replace"
      }), " using this config scheme:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "{\n  resolve: 'gatsby-plugin-postcss',\n  options: {\n    postCssPlugins: [\n      require('postcss-replace')({\n        pattern: /#([A-Fa-f0-9]+)/,\n        data: {\n          '007272': '#YOUR_COLOR' // sea-green\n        }\n      })\n    ]\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
